import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import WalletIntro from './WalletIntro';
import styles from './styles';

function mapStateToProps(state) {
  const { isLoading, data } = state.dev;
  return {
    isLoading,
    data,
  };
}

const Styled = withStyles(styles)(WalletIntro);

export default connect(
  mapStateToProps,
)(Styled);
